<template>
<div class="keys">
  <div class="d-flex wrap gap-10">
    <div class="key" v-for="(item, index) in renderKeys" :key="index">
      <div class="d-flex between input200 design-item" v-if="mode === 'design'">
        <p
          :class="{
            // 'required': item.required,
            'focusing': activeKey === item.apiKey
          }"
          style="cursor: pointer"
          @click="toggleActiveKey(item)"
        >
          {{ item.title }}
        </p>
        <el-popover
          placement="right"
          width="100"
          :trigger="_allMethodTypes(item) ? 'hover': 'manual'">
          <div class="method-list">
            <p
              v-for="(method, index) in _addMethodTypes(item)"
              :key="index"
              @click.prevent.stop="addByMethodType(item, method)"
            >
              {{ method.title }}
            </p>
          </div>
          <el-button
            slot="reference"
            class="ml5"
            type="primary"
            plain
            size="small"
            icon="el-icon-plus"
            @click="handleAdd(item)"
          ></el-button>
        </el-popover>
      </div>
      <!-- 如果是编辑的时候 -->
      <div
        v-else
        class="design-item"
        @click="toggleActiveKey(item)"
        >
        
        <p
          class="key-title"
          :class="{'active': item.apiKey === activeKey, 'required': item.required}"
        >{{ item.title }}</p>
        <el-select
          v-if="item.methodType === 'select' && item.isDict"
          class="input200"
          filterable
          remote
          clearable
          :remote-method="(query) => {
            remoteMethod(query, item.optionType)
          }"
          @focus="remoteMethod('', item.optionType)"
          v-model="model[item.apiKey]"
          @change="handleChange(item)"
          :disabled="!inList.map(i => i.key).includes(item.apiKey) || disabledKeys.includes(item.apiKey)"
        >
          <el-option
            v-for="(item, index) in opts(item.optionType)"
            :key="`${index}-${item.id}`"
            :label="item.name"
            :value="item.value">
          </el-option>
        </el-select>
        <el-autocomplete
          v-if="item.methodType === 'select' && !item.isDict"
          v-model="item.text"
          class="input200"
          :fetch-suggestions="(query, cb) => {
            const {
              isDict,
              optionType
            } = item
            if (isDict && options[optionType]) {
              cb(options[optionType])
            } else {
              remoteMethod(query, item.optionType, cb)
            }
          }"
          :placeholder="`请输入`"
          value-key="name"
          @select="(select) => {
            selectChange(select, item)
          }"
          @input="selectInput(item)"
          clearable
        ></el-autocomplete>
        <el-input-number
          v-else-if="item.methodType === 'number'"
          class="input200"
          v-model="model[item.apiKey]"
          :min="0"
          @change="handleChange(item)"
          :disabled="!inList.map(i => i.key).includes(item.apiKey) || disabledKeys.includes(item.apiKey)"
        ></el-input-number>
        <el-date-picker
          v-else-if="item.methodType === 'datetime' || item.methodType === 'date'"
          class="input200"
          v-model="model[item.apiKey]"
          :type="item.methodType"
          :value-format="item.methodType === 'datetime' ? 'yyyy-MM-dd HH:mm:ss' : 'yyyy-MM-dd'"
          :disabled="!inList.map(i => i.key).includes(item.apiKey) || disabledKeys.includes(item.apiKey)"
          @change="handleChange(item)"
          :picker-options="{
            disabledDate: (date) => {
              return disabledDate(date, item)
            }
          }"
          @focus="defaultSterilizeTime(item)"
        >
        </el-date-picker>
        <el-time-picker
          v-else-if="item.methodType === 'time'"
          class="input200"
          v-model="model[item.apiKey]"
          :value-format="'HH:mm:ss'"
          :disabled="!inList.map(i => i.key).includes(item.apiKey) || disabledKeys.includes(item.apiKey)"
          @change="handleChange(item)"
        >
        </el-time-picker>
        <el-input
          v-else-if="item.methodType === 'list'"
          class="input200"
          v-model="item.title"
          disabled
        ></el-input>
        <div
          v-else-if="item.methodType === 'logo'"
          class="item-placeholder"
        >
          {{ item.title }}
        </div>
        <div
          v-else-if="item.methodType === 'serial_number'"
          class="item-placeholder"
        >
          {{ `流水号` }}
        </div>
        
      </div>
    </div>
  </div>
  <div v-if="mode === 'design'" class="design-item mt10 d-flex">
    <p>标签显示文本</p>
    <el-input
      class="input200 ml10"
      v-model="text"
      :placeholder="`请输入`"
    ></el-input>
    <el-button
      class="ml20"
      type="primary"
      plain
      size="small"
      icon="el-icon-plus"
      @click="addText()"
    ></el-button>
    <p class="ml20">标签识别码</p>
    <el-button
      class="ml20"
      type="primary"
      plain
      size="small"
      icon="el-icon-plus"
      @click="addIdenCode()"
    ></el-button>
  </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import KeysMixin from '../mixins/keys'
import {
  userOptions,
  departmentOptions,
  instrumentPackageOptions,
  getPackageDetail,
  getEquipment,
  getSterilizeDeadlineDate,
  getLastPrint
} from '@/api.js'

export default {
  name: 'Keys',
  mixins:[
    KeysMixin
  ],
  props: {
    isPublic:{
      type:Boolean,
      default:false
    },
    mode: {
      type: String,
      default: 'design' // design, edit
    },
    itemIndex: {
      type: Number,
      default: 0
    },
    inList: {
      type: Array,
      default: () => []
    },
  },
  computed: {
    ...mapGetters(['system']),
    renderKeys() {
      let keys = []
      if (this.mode === 'edit') {
        keys =  this.keys
        .filter(i => i.methodType !== 'logo' && i.methodType !== 'serial_number') // 编辑打印时暂时隐藏logo字段、流水号字段
        .filter(i => this.inList.map(i => i.key).includes(i.apiKey))
        .map(i => {
          // if (i.apiTextKey) {
          //   const item = this.inList.find(l => l.key === i.apiKey)
          //   i.text = item ? item.text : ''
          //   i.text = i.text.replace(/\([^)]*\)/g, "") // 将数据从“灭菌器(一维码)”的格式，整理为：“灭菌器”
          // }
          // 给“灭菌时间”设置当下的时间作为默认值。
          if(i.apiKey == "sterilization_time"){
            this.$nextTick(()=>{
              this.defaultSterilizeTime(i)
            })
          }
          return i
        })
      } else if (this.mode === 'design') {
        keys = this.keys
      }
      return keys
    }
  },
  data() {
    return {
      model: {},
      keys: [],
      text: '',
      activeKey: '',
      options: {
        Department: [],
        Type: [],
        User: [],
        Sterilizer: [],
        Pack: [],
        SterilizeMethod: [],
        Package: []
      }
    }
  },
  methods: {
    initKeys() {
      this.keys = this.allKeys.map(i => Object.assign({}, i))
    },
    getOptions() {
      if (this.mode === 'edit') {
        return Promise.all([
          this.getDicts()
        ])
      }

      return new Promise(r => r())
    },
    opts(type) {
      return this.options[type]
    },
    remoteMethod(query, optionType, cb) {
      switch (optionType) {
        case 'User':
          this.getUserOptions(query)
          .then(res => {
            cb(res)
          })
          break;

        case 'Department':
          this.getDepartmentOptions(query)
          .then(res => {
            cb(res)
          })
          break;

        case 'Package':
          this.getPackageOptions(query)
          .then(res => {
            cb(res)
          })
          break;

        case 'Sterilizer': // 灭菌器
          this.getEquipments(2)
          .then(res => {
            cb(res)
          })
      }
    },
    getUserOptions(name) {
      const url = userOptions.replace('{type}', 0)
      return this.$request('get', url, { name } ).then((res) => {
        const options = res.map(i => Object.assign(i, { value: i.id }))
        this.options['User'] = options

        return options
      })
    },
    getDepartmentOptions(name) {
      return this.$request('get', departmentOptions, { name }).then((res) => {
        const options = res.map(i => Object.assign(i, { value: i.id }))
        this.options['Department'] = options

        return options
      })
    },
    getPackageOptions(name) {
      const params = {
        search: name || '',
        type: this.model.instrumentset_type || undefined
      }

      return this.$request('post', instrumentPackageOptions, params)
      .then((res) => {
        if (res) {
          const options = res.map(i => Object.assign(i, { value: i.id }))
          this.options['Package'] = options

          return options
        }
      })
    },
    getEquipments(type = 2) {
      // 获取灭菌器选项
      const query = {
        type
      }
      return this.$request('get', getEquipment, query)
      .then((res) => {
        if (res) {
          const options = res.map(i => Object.assign(i, { value: i.id }))
          this.options['Sterilizer'] = options
          return options
        }
      })
    },
    getDicts() {
      return this.$utils.getDict([314, 5, 338])
      .then(res => {
        if (res) {
          this.options['Type'] = res[314]
          this.options['Pack'] = res[5]
          this.options['SterilizeMethod'] = res[338]
        }
      })
    },
    pulickModify(item,publicData){
      for(let key in publicData){
        this.$set(this.model,key,publicData[key])
      }
      this.handleChange(item)
    },
    getSterilizeDeadline() {
      if(this.isPublic){ // 如果是公共标签信息里的不用修改灭菌失效日期
        return
      }
      const {
        sterilization_time,
        handle_option,
        pack_option,
        instrumentset_id
      } = this.model
      if (!sterilization_time || !handle_option || !(pack_option && instrumentset_id)) {
        this.sterilizeDeadlineData = ''
        return new Promise(r => r(null))
      }
      const query = {
        sterilization_time,
        handle_option,
        pack_option,
        id: instrumentset_id
      }
      if( JSON.stringify(this.sterilizeDeadlineData) ==  JSON.stringify(query)){ // 清除重复请求
        return
      }
      this.sterilizeDeadlineData = query
      return this.$request('get', getSterilizeDeadlineDate, query)
      .then(res => {
        return res ? res.deadline_date : null
      })
    },
    async syncSterilizeDeadline(apiKey) {
      // 同步灭菌失效日期功能
      const sterilizeDeadlineFactorKeys = [
        'sterilization_time',
        'handle_option',
        'pack_option',
        'instrumentset_id'
      ]
      if (sterilizeDeadlineFactorKeys.includes(apiKey)) {
        const sterilization_expire_time = await this.getSterilizeDeadline()
        if (sterilization_expire_time) {
          this.updateData('sterilization_expire_time', sterilization_expire_time, sterilization_expire_time)
        } else {
          this.updateData('sterilization_expire_time', '', undefined)
        }
      }
    },
    async syncPackageDetail(apiKey) {
      // 同步器械明细
      if (apiKey === 'instrumentset_id') {
        const id = this.model.instrumentset_id
        const url = getPackageDetail.replace('{id}', id)
        this.$request('get', url)
        .then(res => {
          if (res) {
            const {
              instrument
            } = res
            const list = instrument.map(i => {
              return {
                name: i.name,
                number: i.number
              }
            })
            this.updateInlist('instruments', `器械明细`, list)
          }
        })
      }
    },
    syncSterilizeMethod(apiKey) {
      // 同步灭菌方式
      if (apiKey === 'equipment_id') {
        const sterilizeMethodKeys = this.inList.filter(i => i.key === 'handle_option')
        if (sterilizeMethodKeys.length) {
          const handleType = this.options.Sterilizer.filter(i => i.id === this.model.equipment_id)[0]['handle_type']
          if (!handleType) {
            this.updateData('handle_option', `灭菌方式`, undefined)
            return
          }
          const item = this.options.SterilizeMethod.filter(i => i.value === handleType)[0]
          const {
            name,
            value
          } = item
          this.updateData('handle_option', name, value)
        }
      }
    },
    selectInput(item) {
      const {
        apiKey,
        text
      } = item

      this.updateInlist(apiKey, text, undefined)

      if (!text && apiKey === 'instrumentset_id') {
        this.updateInlist('instruments', `器械明细`, [])
      }
    },
    selectChange(select, item) {
      const {
        value
      } = select
      const {
        apiKey,
        text
      } = item
      this.updateData(apiKey, text, value)
      if(item.apiKey == "equipment_id"){
        const i = this.opts('SterilizeMethod').find(i=>i.value == select.handle_type)
        let handleOptionName = i ? i.name : null // 查询当前选择的灭菌器对应的灭菌方式的名称
        if (handleOptionName) {
          this.updateData('handle_option',handleOptionName, select.handle_type) // 选择灭菌器的时候，修改灭菌方式的值。
        }
        
        this.getLastPrintFun(select, item)
      }
      if(item.apiKey == "instrumentset_id"){ 
        const i = this.opts('Pack').find(i=>i.value == select.pack_option)
        let packName = i ? i.name : null // 查询当前选择的器械包对应的包装材料的名称
        if (packName) {
          this.updateData('pack_option',packName,select.pack_option) // 选择器械包的时候，修改包装材料的值。
        }

        this.syncSterilizeDeadline(item.apiKey)
        
        this.syncPackageDetail(apiKey)
      }
    },
    // 这个方法用于更新this.model的值，并且更新打印的数据
    updateData(apiKey, text, value){
      this.$set(this.model,apiKey,value)
      this.updateInlist(apiKey, text, value)
    },
    getLastPrintFun(data){ // 当选择灭菌器时，自动填充灭菌锅次、灭菌时间
      if(!this.isPublic && this.lastPrintData == data.id){ // 如果不是公共标签信息里的不用修改其灭菌锅次、灭菌时间。this.lastPrintData == data.id 是为了清除重复请求
        return
      }
      this.lastPrintData = data.id
      this.$request('get', getLastPrint, {
        equipment_id:data.id
      }).then(res => {
        if(res){
          // 灭菌器变化
          // this.$set(this.model,'sterilization_time',res.sterilization_time)
          // this.updateInlist('sterilization_time', res.sterilization_time, res.sterilization_time)
          // let sterilizationItem = this.allKeys.find(item=>item.apiKey == 'sterilization_time')
          // this.handleChange(sterilizationItem)
          // 锅次变化：
          this.$set(this.model,'sterilization_pot_frequency',res.sterilization_pot_frequency)
          // this.updateInlist('sterilization_pot_frequency', res.sterilization_pot_frequency, res.sterilization_pot_frequency)
          let sterilization_pot_frequency = this.allKeys.find(item=>item.apiKey == 'sterilization_pot_frequency')
          this.handleChange(sterilization_pot_frequency)
        }
      })
    },
    handleChange(item) {
      if(this.isPublic){ // 如果是公共组件调用的，那么还要改动其他组件的内容
        this.$emit('modifySon',item)
      }
      
      // 监听字段变化，统一处理联动相关逻辑
      const {
        apiKey,
        methodType,
        optionType
      } = item
      const value = this.model[apiKey]
      let text = value
      if (methodType === 'select') {
        const options = this.options[optionType]
        const item = options.filter(i => i.value === value)[0]
        text = item ? item.name : ''
      }
      this.updateInlist(apiKey, text, value)
      this.syncSterilizeDeadline(apiKey)
      // this.syncPackageDetail(apiKey)
      this.syncSterilizeMethod(apiKey)
      // 当锅次变化时需要看选中的灭菌器下是否有这个锅次，如果有，那就修改灭菌时间
      // if(item.apiKey == 'sterilization_pot_frequency' && this.model.equipment_id){
      //   this.getLastPrintFun2()
      // }
      
    },
    // 当锅次变化时需要看选中的灭菌器下是否有这个锅次，如果有，那就修改灭菌时间
    getLastPrintFun2(){
      if(!this.isPublic){ // 如果不是公共标签信息里的不用修改灭菌日期
        return
      }
      this.$request('get', getLastPrint, {
        equipment_id:this.model.equipment_id,
        sterilization_pot_frequency:this.model.sterilization_pot_frequency
      }).then(res => {
        // 修改灭菌时间
        if(res){
          this.$set(this.model,'sterilization_time',res.sterilization_time)
        }else{
          //如果后台没有返回值，那就设置为当前时间
          this.$set(this.model, 'sterilization_time', this.$moment(this.system.now).format('yyyy-MM-DD HH:mm:ss'))
        }
        let sterilizationItem = this.allKeys.find(item=>item.apiKey == 'sterilization_time')
        this.handleChange(sterilizationItem)
      })
    },
    updateInlist(key, text, value) {
      this.inList.forEach(i => {
        if (i.key === key) {
          const {
            type,
            printForm
          } = i
          if (this.dateTimeTypes.map(i => i.key).includes(type) && value) {
            const dateArray = value.split(' ')
            if (type === 'date') {
              text = dateArray[0] || ''
            } else if (type === 'time') {
              text = dateArray[1] || ''
            } else if (type === 'datetime') {
              text = value
            }
          }
          if (this.imgTypes.includes(printForm) && value) {
            let img = this.generateCodeImg(printForm, value)
            this.$set(i, 'img', img)
          }
          this.$set(i, 'text', text)
          this.$set(i, 'value', value)
          if (type === 'list') {
            this.$set(i, 'list', value)
          }
        }
      })
    },
    handleAdd(item) {
      // 添加字段（配置设计时使用）
      const { methodType: type, key, apiKey, value, list, title } = item
      if (this._allMethodTypes(item)) {
        return
      }
      const text = title
      const data = {
        id: `${this.itemIndex}-${key}`,
        key: apiKey,
        text,
        value,
        img: this.generateCodeImg(type, value),
        list,
        type,
        describe: title
      }
      this.add(data)
    },
    addByMethodType(item, method) {
      const { apiKey, value, list, title } = item
      let text = title
      text = title + '(' + method.title + ')'
      let methodKey = ''
      let printForm = ''
      printForm = method.key
      if(item.showFormat == 'printForm'){// 判断是特殊（日期，log）的弹框，还是普通的（二维码，一维码的弹框）
        methodKey = item.methodType
        if(method.key == 'select'){
          printForm = item.methodType
        }
      }else{
        methodKey = method.key
      }

      const data = {
        id: `${this.itemIndex}-${methodKey}`,
        key: apiKey,
        text,
        value,
        img: '',
        list,
        type: methodKey,
        describe: title,
        printForm
      }
      
      this.add(data)
    },
    addDateTime(item, dateType = 'datetime') {
      const { key, apiKey, value, list, title } = item

      let text = title
      if (dateType === 'date') {
        text = `${title}（年月日）`
      } else if (dateType === 'time') {
        text = `${title}（时分秒）`
      } else if (dateType === 'datetime') {
        text = `${title}（年月日+时分秒）`
      }
      const data = {
        id: `${this.itemIndex}-${key}`,
        key: apiKey,
        text,
        value,
        img: '',
        list,
        type: dateType,
        describe: title
      }
      
      this.add(data)
    },
    addText() {
      // 添加文本
      if (!this.text) return
      const data = {
        id: `${this.itemIndex}-text`,
        key: '_label',
        text: this.text,
        img: '',
        type: 'label',
        describe: `固定值`,
        printForm: "label",
      }

      this.add(data)
      this.$nextTick(() => {
        this.text = ''
      })
    },
    addIdenCode(){
      const data = {
        id: `idenCode`,
        key: 'labelIdenCode',
        text: `标签识别码`,
        img:'',
        type: 'label',
        describe: `标签识别码`,
        printForm: "qrcode",
      }

      this.add(data)
      this.$nextTick(() => {
        this.text = ''
      })
    },
    add(obj) {
      // 添加方法
      const data = {
        id: '',
        key: '',
        text: '',
        img: '',
        describe: '',
        type: '' // label, text, qrcode, code128, datamatrix, date, datetime, time
      }
      const item = Object.assign({}, data, this.defaultStyle, obj)
      this.$emit('add', item)
    },
    generateCodeImg(type, content) {
      // 生成码图像
      if (this.imgTypes.includes(type)) {
        return this.$utils.generateCode(content, type)
      }
      return undefined
    },
    toggleActiveKey(item) {
      const {
        apiKey
      } = item
      if(!this.inList.map(i => i.key).includes(apiKey) && this.mode === 'edit') return
      this.activeKey = apiKey
      this.$emit('toggleActiveKey', apiKey)
    },
    disabledDate(date, item) {
      const {
        apiKey
      } = item
      if (apiKey !== 'sterilization_time') { // 目前只有灭菌时间需要限制
        return false
      }
      const datetime = this.$moment(date).unix() * 1000
      const { time : now } = this.system
      const todayStart = this.$moment(now).startOf('day')
      return datetime < todayStart
    },
    defaultSterilizeTime(item) {
      const {
        apiKey
      } = item
      if (apiKey === 'sterilization_time') {
        const { time : now } = this.system
        this.$set(this.model, 'sterilization_time', this.$moment(now).format('yyyy-MM-DD HH:mm:ss'))
        this.$nextTick(() => {
          this.handleChange(item)
        })
      }
    }
  },
  created() {
    this.getOptions()
    this.initKeys()
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/css/common.scss';
  .design-item {
    border: 1px dashed lightgray;
    border-radius: 4px;
    padding: 10px;
    background-color: #fff;
  }
  .method-list {
    p {
      margin: 4px 0;
      padding: 8px 6px;
      border-radius: 4px;
      cursor: pointer;
      &:hover {
        background-color: rgba($color: #000, $alpha: 0.1);
      }
    }
  }
  .key-title {
    cursor: pointer;
    &.active {
      color: $main_color_deep;
    }
  }
  .focusing {
    color: $main_color_deep;
  }
  .item-placeholder {
    width: 200px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    border: 1px solid#E4E7ED;
    background-color: #F5F7FA;
    border-radius: 4px;
    color: #C0C4CC;
  }
</style>